import axios, { AxiosError, AxiosRequestConfig, AxiosResponse } from 'axios';
import Interceptor from '../../shared/helpers/axios.interceptor';
import { routeConstants } from '../../shared/routes/route.constants';
import { authHeader } from '../../shared/helpers/authHeader';
import { ICookingMethodForm, ICookingMethodResponse } from './cooking.methods.interfaces';
import { cookingMethodsEndpoints } from './cooking.methods.endpoints';
import { IFilters, IPagination } from '../../shared/components/interfaces';
import { camelToSnakeCase } from '../../shared/helpers/camelToSnakeCase';

axios.interceptors.request.use(function (config) {
    config.headers.Authorization = localStorage.getItem('token');

    return config;
});
axios.interceptors.response.use((response) => {
    return response;
}, Interceptor(axios));

const getCookingMethods = async (
    paging: IPagination,
    searchText?: string,
    filters?: IFilters,
): Promise<ICookingMethodResponse | AxiosError> => {
    const requestOptions: AxiosRequestConfig = {
        url: cookingMethodsEndpoints.GET_COOKING_METHODS.url,
        method: routeConstants.METHODS.GET,
        headers: authHeader(),
        params: {
            page: paging.page,
            paging: paging.paging,
            size: paging.size,
            orderBy: camelToSnakeCase(paging.orderBy),
            orderDirection: paging.orderDirection,
            searchText,
        },
    };

    const response = await axios(requestOptions);

    return response.data.data;
};

const addCookingMethod = async (cookingMethodData: ICookingMethodForm): Promise<ICookingMethodResponse> => {
    const requestOptions: AxiosRequestConfig = {
        url: cookingMethodsEndpoints.ADD_COOKING_METHOD.url,
        method: routeConstants.METHODS.POST,
        headers: authHeader(),
        data: cookingMethodData,
    };

    const response = await axios(requestOptions);

    return response.data;
};

const deleteCookingMethod = async (cookingMethodId: number): Promise<AxiosResponse> => {
    const requestOptions: AxiosRequestConfig = {
        url: cookingMethodsEndpoints.DELETE_COOKING_METHOD.url + cookingMethodId,
        method: routeConstants.METHODS.DELETE,
        headers: authHeader(),
    };

    const response = await axios(requestOptions);

    return response.data;
};

const updateCookingMethod = async (
    cookingMethodData: ICookingMethodForm,
    cookingMethodId: number,
): Promise<ICookingMethodResponse> => {
    const requestOptions: AxiosRequestConfig = {
        url: cookingMethodsEndpoints.UPDATE_COOKING_METHOD.url + cookingMethodId,
        method: routeConstants.METHODS.PUT,
        headers: authHeader(),
        data: cookingMethodData,
    };

    const response = await axios(requestOptions);

    return response.data;
};

export const cookingMethodService = {
    getCookingMethods,
    addCookingMethod,
    deleteCookingMethod,
    updateCookingMethod,
};
